import React from "react";
import { Link } from "react-router-dom";

class NotFoundPage extends React.Component {
  render() {
    return (
      <div className="vh-100 d-flex align-items-center">
        <div className="container text-center">
          <img
            className="img-fluid mb-4"
            width="220"
            src="/404-error.png"
            alt="Page unavailable illustration"
          />
          <h2 className="fw-bold text-dark">
            This page is currently unavailable
          </h2>
          <p className="text-muted mb-4">
            We're working hard to fix this. Please check back soon!
          </p>

          {/* <Link className="btn btn-primary px-4 py-2" to="/categories">
            Go Back Home
          </Link> */}
        </div>
      </div>
    );
  }
}

export default NotFoundPage;
